import { cloneDeep } from 'lodash-es';

import type { RelativeAbsolutePosition } from '../types/pointer-events.js';

export const getSelectionPixels = (
  percentage: [number, number] | undefined,
  width: number,
  position: [RelativeAbsolutePosition, RelativeAbsolutePosition],
) => {
  if (!percentage) {
    return position;
  }

  return position.map((pos, i) => {
    const clone = cloneDeep(pos);
    clone.relative.x = (width * percentage[i]) / 100;

    return clone;
  }) as [RelativeAbsolutePosition, RelativeAbsolutePosition];
};
